<template>
  <v-container fluid class="pa-5">
    <v-layout row align-center justify-space-between>
      <v-flex>
        <span class="headline">
          Plantillas de whatsapp
        </span>
      </v-flex>
      <v-flex md3>
        <v-btn
          class="k-orange-linear white--text"
          block
          large
          @click="openSaveWhatsappTemplateDialog()"
        >
          Crear plantilla
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row mt-3 mb-4>
      <v-flex md8>
        <v-text-field
          v-model="search"
          label="Buscar..."
          color="black"
          solo
        />
      </v-flex>
      <v-flex md4 pl-3>
        <v-select
          v-model="statusFilter"
          :items="statusOptions"
          item-value="value"
          item-text="text"
          label="Estado"
          color="black"
          solo
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <data-table
          url="whatsapp_templates"
          :search="search"
          :filters="tableFilters"
          :refresh="refresh"
          @items-reload="whatsappTemplates = $event"
        >
          <template slot="content" v-for="(whatsappTemplate, index) in whatsappTemplates">
            <whatsapp-template-item
              :key="`whatsapp-template-${whatsappTemplate.id}`"
              :whatsapp-template="whatsappTemplate"
              @edit="openSaveWhatsappTemplateDialog($event)"
              @delete="openDeleteWhatsappTemplateDialog($event)"
              @approve="openUpdateStatusDialog($event, 'APPROVED')"
              @reject="openUpdateStatusDialog($event, 'REJECTED')"
            />
            <v-divider v-if="index !== whatsappTemplates.length - 1" />
          </template>
        </data-table>
      </v-flex>
    </v-layout>
    <save-whatsapp-template-dialog
      v-bind="saveWhatsappTemplateDialog"
      @saved="refresh = !refresh"
      @close="saveWhatsappTemplateDialog.show = false"
    />
    <delete-whatsapp-template-dialog
      v-bind="deleteWhatsappTemplateDialog"
      @deleted="refresh = !refresh"
      @close="deleteWhatsappTemplateDialog.show = false"
    />
    <update-status-whatsapp-template-dialog
      v-bind="updateStatusWhatsappTemplateDialog"
      @updated="refresh = !refresh"
      @close="updateStatusWhatsappTemplateDialog.show = false"
    />
  </v-container>
</template>

<script>
import DataTable from '@/components/global/DataTable2';
import WhatsappTemplateItem from './WhatsappTemplateItem';
import SaveWhatsappTemplateDialog from './SaveWhatsappTemplateDialog';
import DeleteWhatsappTemplateDialog from './DeleteWhatsappTemplateDialog';
import UpdateStatusWhatsappTemplateDialog from './UpdateStatusWhatsappTemplateDialog';

export default {
  components: {
    DataTable,
    WhatsappTemplateItem,
    SaveWhatsappTemplateDialog,
    DeleteWhatsappTemplateDialog,
    UpdateStatusWhatsappTemplateDialog,
  },
  mounted() {
    this.getWhatsappPhones();
  },
  data() {
    return {
      search: '',
      statusFilter: '',
      statusOptions: [
        { text: 'Todos', value: '' },
        { text: 'Pendiente', value: 'PENDING' },
        { text: 'Aprobada', value: 'APPROVED' },
        { text: 'Rechazada', value: 'REJECTED' },
      ],
      refresh: false,
      whatsappTemplates: [],
      saveWhatsappTemplateDialog: {
        show: false,
        phones: [],
        whatsappTemplate: {},
      },
      deleteWhatsappTemplateDialog: {
        show: false,
        whatsappTemplate: {},
      },
      updateStatusWhatsappTemplateDialog: {
        show: false,
        whatsappTemplate: {},
        status: 'APPROVED',
      },
    };
  },
  computed: {
    tableFilters() {
      if (!this.statusFilter) {
        return {};
      }
      return {
        status: this.statusFilter,
      };
    },
  },
  methods: {
    getWhatsappPhones() {
      const UNIVERSAL_WHATSAPP_OUTBOUND_TYPE_ID = 49;
      const UNIVERSAL_COLLY_WHATSAPP_OUTBOUND_TYPE_ID = 50;
      const UNIVERSAL_COUNTRY_WHATSAPP_OUTBOUND_TYPE_ID = 51;
      this.axios.get('whatsapp_templates/phones')
        .then(({ data }) => {
          this.saveWhatsappTemplateDialog.phones = data.map((phone) => {
            if (phone.type_id === UNIVERSAL_COUNTRY_WHATSAPP_OUTBOUND_TYPE_ID) {
              return { ...phone, full_phone: 'Número universal por país' };
            }
            if (
              phone.type_id === UNIVERSAL_WHATSAPP_OUTBOUND_TYPE_ID
              || phone.type_id === UNIVERSAL_COLLY_WHATSAPP_OUTBOUND_TYPE_ID
            ) {
              return { ...phone, full_phone: 'Número universal' };
            }
            return phone;
          });
        });
    },
    openSaveWhatsappTemplateDialog($event) {
      this.saveWhatsappTemplateDialog.show = true;
      this.saveWhatsappTemplateDialog.whatsappTemplate = $event || {};
    },
    openDeleteWhatsappTemplateDialog($event) {
      this.deleteWhatsappTemplateDialog = {
        show: true,
        whatsappTemplate: $event,
      };
    },
    openUpdateStatusDialog($event, status) {
      this.updateStatusWhatsappTemplateDialog = {
        show: true,
        whatsappTemplate: $event,
        status,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/WhatsappTemplates/Index.vue